import {DashboardGraph} from "../dashboard_graph";
import {scaleNumber} from "../../helpers/scaling";

export class ShaperFlowGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = {
            xAxis: {
                type: 'category',
                data: [],
                axisLabel: {
                    formatter: function (val)
                    {
                        return new Date(parseInt(val) * 1000).toLocaleString();
                    },
                    hideOverlap: true
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (val) => {
                        return scaleNumber(Math.abs(val), 0);
                    },
                }
            },
            series: [],
            legend: {
                data: []
            },
        };
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        this.option = {
            xAxis: {
                type: 'category',
                data: [],
                axisLabel: {
                    formatter: function (val)
                    {
                        return new Date(parseInt(val) * 1000).toLocaleString();
                    },
                    hideOverlap: true
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (val) => {
                        return scaleNumber(Math.abs(val), 0);
                    },
                }
            },
            series: [],
            legend: {
                data: []
            },
        };

        this.option.xAxis.data = [];

        // Add series for each shaper
        let n = 0;
        this.option.series[0] = {
            type: 'line',
            data: [],
            name: "Active Flows",
            smooth: true,
            areaStyle: { opacity: 0 },
            itemStyle: {
                color: window.graphPalette[n]
            },
            series: [{}],
        };
        data.forEach((r) => {
            this.option.xAxis.data.push(r.time);
            this.option.series[0].data.push(r.median_flows);

            n++;
        });

        // Apply
        this.chart.setOption(this.option);
    }
}